import {
  contractPeriodList,
  getContractDetails,
  getContractType,
  createContract,
  contractDetailsEdit,
  editContract,
  deleteContractPeriod,
} from "@/http/setup/contractPeriod.js";

export default {
  namespaced: true,
  state: {
    listContractPeriod: [],
    contractDetailsById: {},
    contractTypeOptions: [],
    contractDetailsToEdit: {}
  },
  actions: {
    async fetchContractPeriodList({ commit }) {
      try {
        const res = await contractPeriodList();
        commit("CONTRACT_PERIOD_LIST", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchContractDetails({ commit }, id) {
      try {
        const res = await getContractDetails(id);
        commit("CONTRACT_DETAILS", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchContractType({ commit }) {
      try {
        const res = await getContractType();
        commit("CONTRACT_TYPES", res.data.allowedperiods);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editContractDetails({commit}, id) {
      try {
        const res = await contractDetailsEdit(id);
        commit("EDIT_CONTRACT_DETAILS", res.data)
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createContractPeriod(_, payload) {
      try {
        return await createContract(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteContractPeriodAction(_, payload) {
      try {
        return await deleteContractPeriod(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editContractPeriod(_, payload) {
      try {
        return await editContract(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    CONTRACT_PERIOD_LIST(state, payload) {
      state.listContractPeriod = payload;
    },
    CONTRACT_DETAILS(state, payload) {
      state.contractDetailsById = payload;
    },
    CONTRACT_TYPES(state, payload) {
      state.contractTypeOptions = payload;
    },
    EDIT_CONTRACT_DETAILS(state, payload) {
      state.contractDetailsToEdit = payload;
    },
  },
  getters: {},
};
